import React from 'react';
import * as S from './PopupMmtStyles';

const PopUpMmt = ({
  shouldShow = false,
  onCrossClick,
  popUpMessage
}) => {
  const actionClicked = () => {
    onCrossClick();
  };

  return shouldShow ? (
    <S.ModalWebWrapper>
      <S.ModalContainer>
        <S.Container>
          <S.ContentContainer>
            <S.Content>{popUpMessage}</S.Content>
            <S.ButtonView>
              <S.ButtonTextWrapper>
                <S.ButtonText onClick={actionClicked}>Okay</S.ButtonText>
              </S.ButtonTextWrapper>
            </S.ButtonView>
          </S.ContentContainer>
        </S.Container>
      </S.ModalContainer>
    </S.ModalWebWrapper>
  ) : null;
};

export default PopUpMmt;